/* eslint-disable max-len */
import { Box, BoxProps, chakra } from '@chakra-ui/react';
import React, { FC } from 'react';

interface PlantProps extends BoxProps {
  stepNum: number;
}

const Plant: FC<PlantProps> = ({ stepNum, ...props }) => {
  const step = `step${stepNum}`;
  const colors = {
    orange: '#FE7820',
    tangerine: '#F45264',
    pink: '#C44F8D',
    purple: '#805797',
    blue: '#445580',
    greyDark: '#2F4858',
    white: '#FFFFFF'
  }
  return (
    <Box bottom={0} left={0} width='100%' objectFit='contain' lineHeight={0} mb='-2px' {...props}>
      <chakra.svg
        position='relative'
        display='block'
        viewBox='0 0 512 600'
        xmlns='http://www.w3.org/2000/svg'
        preserveAspectRatio='none'
        className='transition duration-300 ease-in-out delay-150'
      >
        <defs>
          <g id='pot-svg' transform='translate(190, 504)'>
            <path d='M12.8336518,23.8307518 L107.079509,23.8307518 C108.297585,23.8307518 109.493878,23.5077555 110.546428,22.8946919 C111.593255,22.2849616 112.430995,21.372632 112.949443,20.2777209 L115.416432,15.0676801 C115.769077,14.3229278 115.63411,13.4386428 115.075355,12.8329959 C114.485954,12.1941294 113.656311,11.8307518 112.78709,11.8307518 L7.25720747,11.8307518 C6.37993222,11.8307518 5.5417002,12.1934884 4.94116545,12.8329959 C4.37678084,13.4340073 4.25123844,14.3249651 4.62757155,15.0585304 L7.37421374,20.4124078 C7.89372099,21.4250545 8.67272323,22.2816514 9.63164058,22.8946919 C10.5877547,23.5059403 11.6988484,23.8307518 12.8336518,23.8307518 Z'
              id='pot-white-out' fill={colors.white} />
            <path d='M9.72476454,17.8307518 L110.544613,17.8307518 C111.979557,17.8307518 113.371338,17.3399601 114.488875,16.4398641 C115.617037,15.5312102 116.464819,14.3216527 116.934097,12.9511854 L119.769018,4.67216564 C120.134546,3.60468955 119.981618,2.42783432 119.355409,1.48923043 C118.734649,0.558795495 117.690092,6.37369751e-15 116.571588,0 L3.82281041,0 C2.69680779,2.06843327e-16 1.64390805,0.557715807 1.01132413,1.48923043 C0.37677187,2.42364356 0.233274503,3.60723928 0.626151134,4.66621634 L3.74767855,13.0801195 C4.2272074,14.3726627 5.01856555,15.5267544 6.05144823,16.4398641 C7.06521545,17.3360751 8.37165036,17.8307518 9.72476454,17.8307518 Z'
              id='pot-bottom' fill={colors.blue} />
            <path d='M7.62477914,20.7705249 L112.761983,20.7705249 L92.0462415,88.4627998 C91.1897191,93.8377887 89.0688949,96.5252832 85.6837691,96.5252832 C80.6060804,96.5252832 40.7124633,96.5252832 35.9811094,96.5252832 C32.8268734,96.5252832 30.5400704,93.8377887 29.1207004,88.4627998 L7.62477914,20.7705249 Z'
              id='pot-top' fill={colors.blue} />
          </g>

          <g id='stem-svg'>
            <path d='M253.380062,581.058809 C250.614656,548.302168 263.481549,462.701302 274.426368,421.818238 C285.371188,380.935173 293.564113,349.846294 297.047275,310.920795 C300.810637,266.569016 296.301595,200.420973 280.759187,154.787419 C265.216778,109.153865 283.53282,154.784993 287.958087,169.153865 C300.269042,207.153865 309.668358,289.056878 303.4845,337.602657 C297.300641,386.148436 289.461692,415.581813 280.759187,457.44155 C272.056681,499.301287 269.758747,546.554517 269.758747,559.03941 C269.758747,567.362672 269.184087,574.702472 268.034765,581.058809 C262.965951,584.647997 258.08105,584.647997 253.380062,581.058809 Z'
              id='stem' fill={colors.orange} />
          </g>

          <g id='capsule-svg'>
            <path d='M14,1.13686838e-13 C10.8860975,1.13686838e-13 7.78302494,1.13686838e-13 4.69078235,1.13686838e-13 C1.59853977,1.13686838e-13 0.0349456488,1.44930834 0,4.34792501 C0.092928143,7.40590644 1.56428239,8.9565981 4.41406274,9 C7.09728969,9 10.2926021,9 14,9 L14,1.13686838e-13 Z'
              id='left' fill={colors.tangerine} />
            <rect id='middle' fill={colors.white} x='14' y='0' width='3' height='9' />
            <path d='M30.6683469,1.13686838e-13 C27.5544444,1.13686838e-13 24.4513718,1.13686838e-13 21.3591292,1.13686838e-13 C18.2668866,1.13686838e-13 16.7032925,1.44930834 16.6683469,4.34792501 C16.761275,7.40590644 18.2326293,8.9565981 21.0824096,9 C23.7656366,9 26.960949,9 30.6683469,9 L30.6683469,1.13686838e-13 Z'
              id='right' fill={colors.purple} transform='translate(23.668347, 4.500000) scale(-1, 1) translate(-23.668347, -4.500000) ' />
          </g>

          <g id='pill-svg'>
            <g>
              <ellipse id='Oval' fill={colors.pink} cx='11.5' cy='10.5' rx='11.5' ry='10.5' />
              <path d='M22.5,9.5 L22.5,11.5 L0.5,11.5 L0.5,9.5 L22.5,9.5 Z' id='Rectangle' fill={colors.white} stroke={colors.white} />
            </g>
          </g>

          <g id='leaf1-svg' >
            <path d='M264.39892,540.467467 C242.011327,504.681512 218.271153,480.350045 193.178398,467.473066 C202.915994,468.87805 218.368249,477.829398 239.535163,494.327109 C239.535163,478.925936 237.963063,468.168746 234.818864,462.055539 C230.102564,452.885729 222.027438,442.751631 209.354333,438.837289 C196.681227,434.922948 179.088202,433.760863 167.305709,436.299076 C155.523215,438.837289 149.975006,437.853084 145.879658,436.299076 C143.149427,435.263071 140.989181,434.053095 139.39892,432.669148 C139.686129,446.59267 141.846375,457.48441 145.879658,465.344368 C151.929582,477.134305 163.766477,505.098571 186.097529,514.839998 C208.428581,524.581425 221.515634,522.967772 237.875928,517.839545 C245.89898,525.076732 248.653158,533.23009 254.371052,542.534591 L256.176347,545.669148 L264.39892,540.467467 Z'
              id='Leaf1' fill={colors.orange} />
          </g>

          <g id='leaf2-svg' >
            <path d='M279.963713,525.187371 L286.799658,525.686658 C291.627529,498.093585 303.711114,482.433584 323.050413,478.706655 C345.852408,476.114118 360.50065,477.896754 371.824627,477.896754 C379.373945,477.896754 388.24504,476.319728 398.437912,473.165675 C388.709559,477.727033 379.838464,480.313995 371.824627,480.926561 C359.803872,481.84541 345.114932,481.637522 336.465936,482.909212 C327.81694,484.180903 313.838893,487.867076 309.625761,494.542474 C325.55303,502.445435 338.06419,507.432972 347.15924,509.505086 C360.801816,512.613257 374.651565,512.881714 385.489601,510.099241 C396.327636,507.316768 413.913552,493.159477 423.523215,473.165675 C429.929657,459.836474 433.409823,451.538003 433.963713,448.270261 C428.045745,449.965307 421.216102,450.81283 413.474782,450.81283 C401.862803,450.81283 384.485441,441.122563 365.159094,440.02295 C345.832746,438.923337 334.398489,439.951082 324.995786,451.886784 C318.727316,459.843918 314.911789,467.504108 313.549202,474.867353 C304.918714,478.077255 298.084542,483.064312 293.046686,489.828526 C288.008829,496.59274 283.647838,508.379021 279.963713,525.187371 Z'
              id='Leaf2' fill={colors.orange} transform='translate(356.963713, 482.686658) rotate(25.000000) translate(-356.963713, -482.686658) ' />
          </g>
          <g id='leaf3-svg' >
            <path d='M69.8245352,59 L74.6715404,57.2014797 C67.5941944,44.196184 61.9796734,35.847069 57.8279774,32.1541349 C51.6004334,26.6147337 37.7323494,15.537482 24.042438,15.0107592 C32.9204397,14.3147572 41.5510096,16.6046455 49.9341475,21.8804238 C60.2315697,28.3609229 64.486308,33.7020154 70.2701662,42.2466859 C73.680419,32.7326046 74.0529437,25.3555672 71.3877403,20.1155738 C67.3899351,12.2555836 58.9484625,3.27018818 45.4652552,0.509800967 C31.982048,-2.25058624 8.62536542,6.40262133 1.67154037,21.5282836 C6.19651904,20.1507315 10.8713318,20.2681116 15.6959786,21.8804238 C22.9329488,24.2988922 33.1126125,38.0068293 41.8217573,43.4682901 C47.6278539,47.1092641 54.4466113,47.2977595 62.2780296,44.0337765 L69.8245352,59 Z'
              id='leaf3' fill={colors.orange} />
            <path d='M0.499111023,24.6407884 C5.33617714,22.7189572 11.1610938,22.9153555 14,23.9809309 C11.4768192,25.9489528 9.61179803,28.0525562 8.40493648,30.291741 C7.19807494,32.5309259 6.63668262,35.4949344 6.72075951,39.1837668 C5.23928072,38.9490525 3.59176956,37.6369663 1.77822602,35.2475084 C-0.0353175119,32.8580505 -0.461689178,29.3224772 0.499111023,24.6407884 Z'
              id='leaf3-tip' fill={colors.orange} />
          </g>
        </defs>

        {/* Stem */}
        <g id='stem' stroke='none' fill='none' fillRule='evenodd' >
          <g className={`${stepNum !== 0 && 'stem-position'}`}>
            <use className={`${step}-stem-animation`} xlinkHref='#stem-svg' />
            <use className='transparent' xlinkHref='#stem-svg' />
          </g>
        </g>

        {/* Top Fruit */}
        <g id='top-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-top-capsule-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#capsule-svg' />
          </g>
          <g className={`transparent ${step}-top-pill-position`}>
            <use className={`${step}-animation-rev-fast`} xlinkHref='#pill-svg' />
          </g>
        </g>

        {/* Top Left Fruit */}
        <g id='top-left-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-top-left-stem-position`}>
            <use className={`${step}-grow-animation-fast`} xlinkHref='#stem-svg' />
          </g>
          <g className={`transparent ${step}-top-left-capsule1-position`}>
            <use className={`${step}-animation-med`} xlinkHref='#capsule-svg' />
          </g>
          <g className={`transparent ${step}-top-left-capsule2-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#capsule-svg' />
          </g>
        </g>

        {/* Top Right Fruit */}
        <g id='top-right-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-top-right-stem-position`}>
            <use className={`${step}-grow-animation-med`} xlinkHref='#stem-svg' />
          </g>
          <g className={`transparent ${step}-top-right-capsule-position`}>
            <use className={`${step}-animation-fast`} xlinkHref='#capsule-svg' />
          </g>
          <g className={`transparent ${step}-top-right-pill-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#pill-svg' />
          </g>
        </g>

        {/* Top Leafs */}
        <g id='top-left-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-top-left-leaf-position`}>
            <use className={`${step}-top-left-leaf-animation`} xlinkHref='#leaf2-svg' />
          </g>
        </g>
        <g id='top-right-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-top-right-leaf-position`}>
            <use className={`${step}-top-right-leaf-animation`} xlinkHref='#leaf3-svg' />
          </g>
        </g>

        {/* Middle Left Fruit */}
        <g id='middle-left-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-middle-left-stem-position`}>
            <use className={`${step}-grow-animation-med`} xlinkHref='#stem-svg' />
          </g>
          <g className={`transparent ${step}-middle-left-pill-position`}>
            <use className={`${step}-animation-fast`} xlinkHref='#pill-svg' />
          </g>
          <g className={`transparent ${step}-middle-left-capsule-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#capsule-svg' />
          </g>
        </g>
        
        {/* Middle Right Fruit */}
        <g id='middle-right-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-middle-right-stem-position`}>
            <use className={`${step}-grow-animation-slow`} xlinkHref='#stem-svg' />
          </g>
          <g className={`transparent ${step}-middle-right-pill-position`}>
            <use className={`${step}-animation-fast`} xlinkHref='#pill-svg' />
          </g>
          <g className={`transparent ${step}-middle-right-capsule1-position`}>
            <use className={`${step}-animation-med`} xlinkHref='#capsule-svg' />
          </g>
          <g className={`transparent ${step}-middle-right-capsule2-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#capsule-svg' />
          </g>
        </g>

        {/* Middle Leafs */}
        <g id='middle-left-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-middle-left-leaf-position`}>
            <use className={`${step}-middle-left-leaf-animation`} xlinkHref='#leaf3-svg' />
          </g>
        </g>
        <g id='middle-right-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-middle-right-leaf-position`}>
            <use className={`${step}-leaf1-grow-animation`} xlinkHref='#leaf1-svg' />
          </g>
        </g>

        {/* Bottom Leafs */}
        <g id='bottom-left-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-bottom-left-leaf-position`}>
            <use className={`${step}-leaf1-grow-animation`} xlinkHref='#leaf1-svg' />
          </g>
        </g>
        <g id='bottom-right-leaf' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-bottom-right-leaf-position`}>
            <use className={`${step}-leaf2-grow-animation`} xlinkHref='#leaf2-svg' />
          </g>
        </g>

        {/* Bottom Fruit */}
        <g id='bottom-fruit' stroke='none' fill='none' fillRule='evenodd'>
          <g className={`transparent ${step}-bottom-stem-position`}>
            <use className={`${step}-grow-animation-slow`} xlinkHref='#stem-svg' />
          </g>
          <g className={`transparent ${step}-bottom-pill1-position`}>
            <use className={`${step}-animation-slow`} xlinkHref='#pill-svg' />
          </g>
          <g className={`transparent ${step}-bottom-pill2-position`}>
            <use className={`${step}-animation-fast`} xlinkHref='#pill-svg' />
          </g>
        </g>

        {/* Pot */}
        <g>
          <use className='pot' xlinkHref='#pot-svg' />
        </g>
      </chakra.svg>
    </Box >
  );
};

export default Plant;